import React, { FunctionComponent } from "react";
import { PersonalTaxFormTitle } from "../PersonalTaxFormTitle";
import { Trans } from "@lingui/macro";
import { useFormikContext } from "formik";
import { DateField } from "components/fields/DateField";
import { useIsSinglePerson } from "../hooks/useIsSinglePerson";
import { InputField } from "components/fields/InputField";
import { NumberField } from "../../../components/fields/NumberField";

export interface Props {}

const useChildrenUnderCareRules = () => {
  const {
    values: { c1030, c1031, c1038, c1039 },
    setFieldValue,
  } = useFormikContext<any>();

  React.useEffect(() => {
    if (c1030 || c1031) {
      const min = Math.min(c1030, c1031)
      setFieldValue("c1031", min >= 0 ? min : undefined);
    }
  }, [c1030, c1031, setFieldValue]);

  React.useEffect(() => {
    if (c1030 || c1038) {
      const min = Math.min(c1030, c1038)
      setFieldValue("c1038", min >= 0 ? min : undefined);
    }
  }, [c1030, c1038, setFieldValue]);

  React.useEffect(() => {
    if (c1030 || c1039) {
      const min = Math.min(c1030, c1031, c1038, c1039)
      setFieldValue("c1039", min >= 0 ? min : undefined);
    }
  }, [c1030, c1031, c1038, c1039, setFieldValue]);
};

const useChildrenUnderMyCare = () => {
  const {
    values: { c1034, c1035, c1054, c1055 },
    setFieldValue,
  } = useFormikContext<any>();

  React.useEffect(() => {
    if (c1034 || c1035) {
      const min = Math.min(c1034, c1035)
      setFieldValue("c1035", min >= 0 ? min : undefined);
    }
  }, [c1034, c1035, setFieldValue]);

  React.useEffect(() => {
    if (c1034 || c1054) {
      const min = Math.min(c1034, c1054)
      setFieldValue("c1054", min >= 0 ? min : undefined);
    }
  }, [c1034, c1054, setFieldValue]);

  React.useEffect(() => {
    if (c1034 || c1055) {
      const min = Math.min(c1034, c1035, c1054, c1055)
      setFieldValue("c1055", min >= 0 ? min : undefined);
    }
  }, [c1034, c1035, c1054, c1055, setFieldValue]);
};

const useChildrenUnderOtherParentsCare = () => {
  const {
    values: { c1036, c1037, c1058, c1059 },
    setFieldValue,
  } = useFormikContext<any>();

  React.useEffect(() => {
    if (c1036 || c1037) {
      const min = Math.min(c1036, c1037)
      setFieldValue("c1037", min >= 0 ? min : undefined);
    }
  }, [c1036, c1037, setFieldValue]);

  React.useEffect(() => {
    if (c1036 || c1058) {
      const min = Math.min(c1036, c1058)
      setFieldValue("c1058", min >= 0 ? min : undefined);
    }
  }, [c1036, c1058, setFieldValue]);

  React.useEffect(() => {
    if (c1036 || c1059) {
      const min = Math.min(c1036, c1037, c1058, c1059)
      setFieldValue("c1059", min >= 0 ? min : undefined);
    }
  }, [c1036, c1037, c1058, c1059, setFieldValue]);
};

const useElderlyUnderMyCare = () => {
  const {
    values: { c1043, c1044 },
    setFieldValue,
  } = useFormikContext<any>();

  React.useEffect(() => {
    if (c1043 || c1044) {
      const min = Math.min(c1043, c1044)
      setFieldValue("c1044", min >= 0 ? min : undefined);
    }
  }, [c1043, c1044, setFieldValue]);
};

const useOtherPeopleUnderMyCare = () => {
  const {
    values: { c1032, c1033 },
    setFieldValue,
  } = useFormikContext<any>();

  React.useEffect(() => {
    if (c1032 || c1033) {
      const min = Math.min(c1032, c1033)
      setFieldValue("c1033", min >= 0 ? min : undefined);
    }
  }, [c1032, c1033, setFieldValue]);
};

export const GezinslastenForm: FunctionComponent<Props> = () => {
  useChildrenUnderCareRules();
  useChildrenUnderMyCare();
  useChildrenUnderOtherParentsCare();
  useElderlyUnderMyCare();
  useOtherPeopleUnderMyCare();
  const isSinglePerson = useIsSinglePerson();

  return (
    <div className="main">
      <div id="tab_expenses">
        <PersonalTaxFormTitle icon="users">
          <Trans>Gezinslasten</Trans>
        </PersonalTaxFormTitle>
        <div className="half" id="half_declarant">
          <div className="titel">
            <h2>
              <Trans>De aangever</Trans>
            </h2>
          </div>
          <div className="veld">
            <label htmlFor="c3004">
              <Trans>Geboortedatum</Trans>
            </label>
            <DateField type="text" id="c3004" name="c3004" className="datum" />
          </div>
          <div className="veld">
            <label htmlFor="c1552">
              <Trans>Zelfstandige vanaf</Trans>
            </label>
            <DateField type="text" id="c1552" name="c1552" className="datum" />
          </div>
          <div className="veld">
            <label htmlFor="c1028">
              <Trans>Gehandicapt</Trans>
            </label>
            <InputField type="checkbox" id="c1028" name="c1028" />
          </div>
        </div>
        {!isSinglePerson && (
          <div className="half" id="half_partner">
            <div className="titel">
              <h2>
                <Trans>De partner</Trans>
              </h2>
            </div>
            <div className="veld">
              <label htmlFor="c3005">
                <Trans>Geboortedatum</Trans>
              </label>
              <DateField type="text" id="c3005" name="c3005" />
            </div>
            <div className="veld">
              <label htmlFor="c2552">
                <Trans>Zelfstandige vanaf</Trans>
              </label>
              <DateField type="text" id="c2552" name="c2552" />
            </div>
            <div className="veld">
              <label htmlFor="c1029">
                <Trans>Gehandicapt</Trans>
              </label>
              <InputField type="checkbox" id="c1029" name="c1029" />
            </div>
          </div>
        )}

        <div className="breed">
          <div className="titel">
            <h2>
              <Trans>Personen ten laste</Trans>
            </h2>
          </div>
          <div className="row">
            <div className="smalveld">
              <label htmlFor="c1030">
                <Trans>Kinderen ten laste</Trans>
              </label>
              <NumberField min="0" id="c1030" name="c1030" decimalScale={0} />
              <span>1030</span>
            </div>
            <div className="smalveld">
              <label htmlFor="c1031">
                <Trans>waarvan gehandicapt</Trans>
              </label>
              <NumberField min="0" id="c1031" name="c1031" decimalScale={0} />
              <span>1031</span>
            </div>
          </div>
          <div className="row">
            <div className="smalveld">
              <label htmlFor="c1038">
                <Trans>{"<"} 3 jaar, geen aftrek kinderopvang</Trans>
              </label>
              <NumberField min="0" id="c1038" name="c1038" decimalScale={0} />
              <span>1038</span>
            </div>
            <div className="smalveld">
              <label htmlFor="c1039">waarvan gehandicapt</label>
              <NumberField min="0" id="c1039" name="c1039" decimalScale={0} />
              <span>1039</span>
            </div>
          </div>

          <div className="container_coouderschap">
            <div className="titel">
              <h2>
                <Trans>Co-ouderschap</Trans>
              </h2>
            </div>
            <div className="row">
              <div className="smalveld">
                <label htmlFor="c1034">
                  <Trans>Fiscaal ten laste</Trans>
                </label>
                <NumberField min="0" id="c1034" name="c1034" decimalScale={0} />
                <span>1034</span>
              </div>
              <div className="smalveld">
                <label htmlFor="c1035">
                  <Trans>waarvan gehandicapt</Trans>
                </label>
                <NumberField min="0" id="c1035" name="c1035" decimalScale={0} />
                <span>1035</span>
              </div>
            </div>

            <div className="row">
              <div className="smalveld">
                <label htmlFor="c1054">
                  <Trans>{"<"} 3 jaar, geen aftrek kinderopvang</Trans>
                </label>
                <NumberField min="0" id="c1054" name="c1054" decimalScale={0} />
                <span>1054</span>
              </div>
              <div className="smalveld">
                <label htmlFor="c1055">
                  <Trans>waarvan gehandicapt</Trans>
                </label>
                <NumberField min="0" id="c1055" name="c1055" decimalScale={0} />
                <span>1055</span>
              </div>
            </div>

            <div className="row">
              <div className="smalveld">
                <label htmlFor="c1036">
                  <Trans>Fiscaal ten laste van de andere ouder</Trans>
                </label>
                <NumberField min="0" id="c1036" name="c1036" decimalScale={0} />
                <span>1036</span>
              </div>
              <div className="smalveld">
                <label htmlFor="c1037">
                  <Trans>waarvan gehandicapt</Trans>
                </label>
                <NumberField min="0" id="c1037" name="c1037" decimalScale={0} />
                <span>1037</span>
              </div>
            </div>

            <div className="row">
              <div className="smalveld">
                <label htmlFor="c1058">
                  <Trans>{"<"} 3 jaar, geen aftrek kinderopvang</Trans>
                </label>
                <NumberField min="0" id="c1058" name="c1058" decimalScale={0} />
                <span>1058</span>
              </div>
              <div className="smalveld">
                <label htmlFor="c1059">
                  <Trans>waarvan gehandicapt</Trans>
                </label>
                <NumberField min="0" id="c1059" name="c1059" decimalScale={0} />
                <span>1059</span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="smalveld">
              <label htmlFor="c1043">
                <Trans>Personen ten laste vanaf 65 jaar</Trans>
              </label>
              <NumberField min="0" id="c1043" name="c1043" decimalScale={0} />
              <span>1043</span>
            </div>
            <div className="smalveld">
              <label htmlFor="c1044">
                <Trans>waarvan gehandicapt</Trans>
              </label>
              <NumberField min="0" id="c1044" name="c1044" decimalScale={0} />
              <span>1044</span>
            </div>
          </div>
          <div className="row">
            <div className="smalveld">
              <label htmlFor="c1032">
                <Trans>Ander personen ten laste</Trans>
              </label>
              <NumberField min="0" id="c1032" name="c1032" decimalScale={0} />
              <span>1032</span>
            </div>
            <div className="smalveld">
              <label htmlFor="c1033">
                <Trans>waarvan gehandicapt</Trans>
              </label>
              <NumberField min="0" id="c1033" name="c1033" decimalScale={0} />
              <span>1033</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GezinslastenForm.displayName = "GezinslastenForm";
